<template>

  <main class="main-content" id="topDom">
    <section class="section">
      <ul class="breadcrumb">
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li">
          <span class="breadcrumb__text"> {{ $t("i18n.presysProcess") }}</span>
        </li>
      </ul>
      <div class="banner" style="cursor: pointer;" :style="{height: (isMobile() ? (windowHeight - 110) + 'px !important' : '61rem')}">
        <img class="mobileBg" v-if="isMobile()" :src="imageSrc" />
        <div class="banner__content container-fluid" v-if="!isMobile()">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ $t("i18n.PresysBriefIntroductionTitle") }}</h1>
              <p class="banner__text" v-html="$t('i18n.PresysBriefIntroductionText')"></p>
            </div>
          </div>
        </div>
        <div class="banner__bg" v-if="!isMobile()">
          <img :src="imgUrl" />
        </div>
      </div>

    </section>

    <section class="section">
      <div class="container-fluid content">
        <div class="row">
          <div class="col-12">
            <div class="accordion-wrapper" v-for="(item, index) of $t('i18n.presysProcessList')" :key="index">
              <div class="accordion-title-year">
                <span>{{ item.year }}</span>
              </div>
              <div class="accordion-item">
                <div class="accordion-title"  v-for="(text, tIndex) of item.textList" :key="tIndex">{{ text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section --banner">
      <div class="container-fluid">
        <div class="row mt-4 mt-md-2">
          <div class="col-6" style="cursor: pointer !important; ">
            <div class="white-box__links">
              <a class="white-box__link" @click="goPage('/')">
                <strong class="white-box__link-label">
                  {{ $t("i18n.company") }}
                </strong>
                <h4 class="white-box__link-text">
                  {{ $t("i18n.backHomePage") }}
                </h4>
              </a>
              <a class="white-box__link ml-auto --b" @click="goPage('Presys')">
                <strong class="white-box__link-label">
                  {{ $t("i18n.company") }}
                </strong>
                <h4 class="white-box__link-text">
                  {{ $t("i18n.PRESYSTitle") }}
                </h4>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "presysProcess",
  data() {
    return {
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      imgUrl: this.isMobile() ? require("../assets/imgs/5-nei.png") : require("../assets/imgs/5-nei.png"),
    }
  },
  // created() {
  //   this.goTop();
  // },
  mounted () {
    this.goTop();
  },
  computed: {
    imageSrc() {
      // 从i18n获取baseUrl，并拼接图片名称
      return this.$t('i18n.bannerBg5');
    }
  },
  methods: {
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    goPage(path) {
      this.$router.push(path)
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    }
  }
}
</script>

<style scoped>

.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #e3e3e3;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #FFFFFF;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner {
  position: relative;
  width: 100%;
  height: 61rem;
  align-items: center;
  display: flex;
  background-image: url(../assets/imgs/5-bg.png);
  background-size: cover; /* 保证背景图片覆盖元素并且不变形 */
  background-position: center; /* 将背景图片居中显示 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  padding: 18rem 0 0 0;
  display: flex;
  flex-direction: column;
}
.banner__bg {
  /* position: absolute;
  width: 100%;
  height: 61rem; */
  /* margin-top: -15rem; */
  position: absolute;
  bottom: 0;
  margin-top: 1rem;
}
.banner__bg {
  z-index: 1;
}
.banner__bg img {
  /* max-width: 100%; */

  display: block;
  width: 100%;
  /* height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%; */
}

.banner__content {
  /* position: relative; */
  position: absolute;
  top: 15%;
  z-index: 2;
}
.banner__title {
  font-weight: 500;
  font-size: 4rem;
  color: #fff;
  letter-spacing: -.084rem;
  line-height: 6rem;
}
.banner__text {
  margin-top: 3rem;
  font-size: 2.1rem;
  font-weight: 500;
  color: #fff;
  letter-spacing: -.022rem;
  line-height: 3.3rem;
  padding-right: 2rem;
}
.accordion-wrapper {
  margin-bottom: 5rem;
  display: flex;
  margin-top: 6rem;
}
.accordion-item {
  border-bottom: .1rem solid #e6e6e6;
  width: 100%;
}
.accordion-title {
  height: 6rem;
  display: flex;
  align-items: center;
  font-size: 2rem;
  letter-spacing: -.02rem;
  line-height: 3rem;
  position: relative;
  transition: all .2s ease-in-out;
  margin-left: 2.5rem;
  font-weight: normal;
  color: #231815;
}

.accordion-title:before{
  content: "";
  position: absolute;
  z-index: 2;
  left: -2rem;
  top: 49%;
  width: 1.5rem;
  height: 1.5rem;
  margin-top: -.4rem;
  background: transparent;
  border: .1rem solid #6C2188;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 1rem;
}
.content {
  margin-top: 5rem;
}

.white-box__links {
  background: #fff;
  display: flex;
  min-height: 8rem;
  overflow: hidden;
  margin-bottom: 6rem;
}
.white-box__link {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 5rem;
  border: 0.2rem solid #e6e6e6;
  border-radius: 1rem;
  transition: all .2s ease-in-out;
  width: 40%;
}
.g-content .white-box__link-label, .white-box__link-label {
  font-weight: 600;
  font-size: 1.4rem;
  color: black;
  letter-spacing: .035rem;
  text-transform: uppercase;
  display: block;
  line-height: 1.7rem;
  margin-bottom: 1rem;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text, .white-box__link-text {
  font-weight: 300;
  font-size: 3rem;
  color: #990099;
  letter-spacing: -.015rem;
  line-height: 3.2rem;
  position: relative;
  padding-right: 1.5rem;
  margin: 0;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text:after, .white-box__link-text:after {
  content: "";
  position: absolute;
  padding-right: 2rem;
  right: 0;
  width: 0.8rem;
  height: 1.4rem;
  top: 1.2rem;
  background: url(../assets/imgs/arrow-right.png) no-repeat 50%;
  transition: all .2s ease-in-out;
}
.accordion-title-year {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  align-items: end;
  margin-right: 2rem;
  color: #FFFFFF;
  position: relative;
  height: 5rem;
}
.accordion-title-year span {
  position: relative;
  z-index: 1;
  top: 2.3rem;
}
.accordion-title-year:after  {
  position: absolute;
  top: 0;
  left: -2.2rem;
  content: "";
  padding-right: 2rem;
  width: 9rem;
  height: 9rem;
  background: url(../assets/imgs/presysProcessItem.png) no-repeat 50%;
  transition: all .2s ease-in-out;
}
@media (max-width: 1023.9px) {
  .white-box__links {
    flex-direction: column;
    height: auto;
    min-height: 0;
    width: calc(100% + 3rem);
    margin-left: -1.5rem;
  }
  .white-box__link {
    padding: 4rem 3rem;
    border: 0;
    border-bottom: .1rem solid #e6e6e6;
    width: auto;
  }
  .ml-auto.--b {
    margin-left: 0 !important;
  }

}
@media (max-width: 768px) {
  .banner__bg{
    margin: 0;
  }
  .banner {
    /* margin-top: -110px; */
    padding-top: 0rem;
    width: 100%;
    background-image: none !important;
    overflow:hidden;
  }
  .mobileBg {
    display: block;
    width: 100%;
    height: auto;
  } 
}
</style>



// WEBPACK FOOTER //
// src/view/presysProcess.vue